import React, { useEffect, useState } from 'react';
import axios from 'axios';

const NotifyRequests = () => {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    axios.get('/api/products/notify-requests')
      .then(res => setRequests(res.data))
      .catch(err => console.error('Failed to load notify requests:', err));
  }, []);

  return (
    <div className="max-w-6xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Notify Me Requests</h1>
      {requests.length === 0 ? (
        <p className="text-gray-500">No requests found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-[600px] w-full bg-white border text-xs sm:text-sm">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="p-1 sm:p-2 border text-xs sm:text-sm">Email</th>
                <th className="p-1 sm:p-2 border text-xs sm:text-sm">Product</th>
                <th className="p-1 sm:p-2 border text-xs sm:text-sm">Size</th>
                <th className="p-1 sm:p-2 border text-xs sm:text-sm">Status</th>
                <th className="p-1 sm:p-2 border text-xs sm:text-sm">Link</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((req, idx) => (
                <tr key={idx} className="border-t">
                  <td className="p-1 sm:p-2 text-xs sm:text-sm">{req.email}</td>
                  <td className="p-1 sm:p-2 text-xs sm:text-sm">{req.productName}</td>
                  <td className="p-1 sm:p-2 text-xs sm:text-sm">{req.size}</td>
                  <td className="p-1 sm:p-2 text-xs sm:text-sm">
                    {req.notified ? (
                      <span className="text-green-600">Notified</span>
                    ) : (
                      <span className="text-yellow-600">Pending</span>
                    )}
                  </td>
                  <td className="p-1 sm:p-2 text-xs sm:text-sm">
                    <a
                      href={`/product/${req.productId}`}
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noreferrer"
                    >
                      View
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
      )}
        </div>
      );
};

      export default NotifyRequests;
